import React from 'react'
import YkPopup from '@yk-component/yk-popup'
import './popup.less'

export default function Popup(props) {
  return (
    <YkPopup {...props} prefixClass="mn" />
  )
}
